import {Group} from "dto/Group"
import {Dispatch, SetStateAction, useEffect, useRef, useState} from "react"
import SortableTree, {defaultSearchMethod} from "react-sortable-tree"
import {TreeNodeData} from "pages/group/GroupListView"

type GroupTreeProps = {
    groups: Group[],
    selectedNode: TreeNodeData | undefined,
    selectNode: Dispatch<SetStateAction<TreeNodeData | undefined>>
}

export function GroupTree({groups, selectedNode, selectNode}: GroupTreeProps) {
    const [treeData, setTreeData] = useState<TreeNodeData[]>()
    const [keyword, setKeyword] = useState<string>()
    const [searchFocusIndex, setSearchFocusIndex] = useState<number>(0)
    useEffect(() => {
        const groupData: Group[] = [{
            name: "그룹",
            subGroups: groups
        }]
        setTreeData(groupData.map(group => convertGroupToTreeData(group)))
    }, [groups])
    if (!treeData) return null
    return (
        <>
            <div className="panel-block-gray mt10">
                <p className="control has-icons-left " style={{display: "none"}}>
                    <input className="input is-info " type="text" placeholder="그룹검색"
                           defaultValue={keyword}
                           onChange={e => setKeyword(e.target.value)}
                    />
                </p>
            </div>
            <div className="panel-box ">
                <div className="panel-02-block pt-5 overflow-hidden overflow-y-auto" style={{maxHeight: 800}}>
                    <SortableTree treeData={treeData}
                                  onChange={(changedData) => {
                                      console.log("treedata : ", changedData)
                                      setTreeData([...changedData])
                                  }}
                                  searchQuery={keyword}
                                  searchMethod={defaultSearchMethod}
                                  searchFinishCallback={matches => {
                                      setSearchFocusIndex(matches.length > 0 ? searchFocusIndex % matches.length : 0)
                                  }}
                                  getNodeKey={({node}) => (`${node.id}/${node.title}`)}
                                  isVirtualized={false} canDrag={false} slideRegionSize={30}
                        // onVisibilityToggle={(data) => {
                        // }}
                                  generateNodeProps={({node, path,isSearchMatch}) => {
                                      // console.log("path: ", path, isSearchMatch)
                                      return {
                                          id: node.id,
                                          style: {
                                              backgroundColor: '#EFEFEF'
                                          },
                                          onClick: (e: Event, data: TreeNodeData) => {
                                              selectNode(node)
                                          },
                                          title: <div
                                              className={ isSearchMatch ? "text-pink-500" : selectedNode?.id === node.id ? `text-amber-600` : ""}>{node.title}</div>,
                                      }
                                  }}
                                  rowHeight={50}
                    />
                    {/*theme={FileExplorerTheme}*/}
                </div>
            </div>
        </>
    )
}


export const convertGroupToTreeData = (group: Group) => {
    const data: TreeNodeData = {
        title: group.name,
        id: group.id || "",
        expanded: true
    }
    if (group.subGroups) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        data.children = group.subGroups.map(subGroup => convertGroupToTreeData(subGroup))
    }
    return data
}